module.exports = __webpack_public_path__ + "static/noni-3a5567bdb6675fc336f3de12eb6cba30.jpg";